import type { SVGProps } from "react";
export const Pinterest = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M10.3571 1C6.65693 1 3 3.4668 3 7.45913C3 9.99806 4.42815 11.4406 5.29369 11.4406C5.65073 11.4406 5.8563 10.4453 5.8563 10.164C5.8563 9.82856 5.00157 9.11448 5.00157 7.71879C5.00157 4.81922 7.20871 2.76355 10.065 2.76355C12.521 2.76355 14.3386 4.15924 14.3386 6.72341C14.3386 8.63843 13.5705 12.2304 11.082 12.2304C10.184 12.2304 9.41585 11.5813 9.41585 10.6508C9.41585 9.28759 10.3679 7.96763 10.3679 6.56112C10.3679 4.17366 6.98151 4.60644 6.98151 7.49158C6.98151 8.09747 7.05724 8.76826 7.32772 9.32005C6.83003 11.4623 5.81302 14.654 5.81302 16.8611C5.81302 17.5427 5.91039 18.2135 5.97531 18.8951C6.09793 19.0322 6.03662 19.0178 6.22415 18.9492C8.0418 16.4608 7.97688 15.9739 8.79915 12.7173C9.24274 13.5612 10.3896 14.0156 11.2984 14.0156C15.1284 14.0156 16.8487 10.283 16.8487 6.91816C16.8487 3.33697 13.7544 1 10.3571 1Z"
			fill="currentColor"
		/>
	</svg>
);
